import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalysisServiceProvider } from "../../providers/analysis-service/analysis-service";
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { /*Analysis, */RequestUser, AnalysisRemove, Venue, /*WishlistAdd, WishlistRemove, WishlistGet, BeerProfileRequest, SearchRequest*/ } from "../../models/models";
//import { trigger, state, style, animate, transition } from '@angular/animations';
import { LoadingController, IonItemSliding, ToastController, IonInfiniteScroll, AlertController } from '@ionic/angular'
import { BeerDetailPage } from '../../pages/beer-detail/beer-detail'
import { UserDataProvider } from '../../providers/user-data/user-data';
import { RefdataProvider } from '../../providers/refdata/refdata'
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { BeerDetailPage_PATH } from '../../app/app-constants';

@Component({
  selector: 'my-analyses',
  templateUrl: 'my-analyses.html',
  styleUrls: ['./my-analyses.scss'],
  standalone: false,
  // imports: [
  //   TranslateModule,
  //   CommonModule,
  //   FormsModule,
  //   IonicModule
  // ]
})

export class MyAnalysesComponent implements OnInit, OnDestroy {
  private beers: Array<any> = [];

  private pageNumber: number = 0;
  private rowCount: number = 20;
  private fetchMore: boolean = true;

  private sortFilter: any = {sortField: "name", direction: "ASC"};
  private selectedVenue: Venue = null;

  isLoading: Array<any> = [];
  loading: HTMLIonLoadingElement = null;

  sortfilterChangedSubscription: any;
  venueSelectedSubscription: any;
  venueDeselectedSubscription: any;
  deleteBeerSubscription: any;

  constructor(
    private analysisService: AnalysisServiceProvider,
    private locationService: LocationServiceProvider,
    private router: Router,
    private userData: UserDataProvider,
    private refdata: RefdataProvider,
    private loadingCtrl: LoadingController,
    private bhutil: BhutilProvider,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private events: AppEventService,
    private storage: Storage
  ) {
  }

  loadInitialbeers() {
    this.userData.init().then(() => {
      this.storage.get('selected-venue').then((venue) => {
        // First read the selected venue from storage
        let venueJSON = JSON.parse(venue);
        if (venueJSON != null) {
          this.selectedVenue = venueJSON;
          console.log("[my-analyses] - currently venue with id selected: " + venueJSON.id);
        }

        this.loadNext(false, null);
      });
    });
  }

  ngOnInit() {
    console.log('[my-analyses] - ngOnInit');
    this.pageNumber = 0;
    this.fetchMore = true;
    this.loadInitialbeers();
    this.subscribeToEvents();
  }

  ngOnDestroy() {
    console.log('[my-analyses] - ngOnDestroy');
    this.unsubscribeFromEvents();
  }

  subscribeToEvents() {
    console.log("[my-analyses] - subscribing to events");

    this.sortfilterChangedSubscription = (sortFilter: any) => {
      console.log("my-analyses - noticed filter sorting changed to:", sortFilter);
      this.sortFilter = sortFilter;
      this.refresh();
    };
    this.events.subscribe("sortfilter:changed", this.sortfilterChangedSubscription);

    this.venueSelectedSubscription = (venue: Venue) => {
      console.log("my-analyses - noticed filter veneu changed to:", venue.id);
      this.selectedVenue = venue;
      this.refresh();
    };
    this.events.subscribe("venue:selected", this.venueSelectedSubscription);

    this.venueDeselectedSubscription = () => {
      console.log("my-analyses - noticed filter veneu changed to: null");
      this.selectedVenue = null;
      this.refresh();
    };
    this.events.subscribe("venue:deselected", this.venueDeselectedSubscription);

    this.deleteBeerSubscription = (deleteBeer) => {
      console.log("my-anaylyses - deleting beer with id", deleteBeer.removalId);
      this.delete(deleteBeer.item, deleteBeer.beer, deleteBeer.removalId);
    }
    this.events.subscribe("delete:beer", this.deleteBeerSubscription);
  }

  unsubscribeFromEvents() {
    console.log("[my-analyses] - unsubscribing from events");
    this.events.unsubscribe("venue:deselected", this.venueDeselectedSubscription);
    this.events.unsubscribe("sortfilter:changed", this.sortfilterChangedSubscription);
    this.events.unsubscribe("venue:selected", this.venueSelectedSubscription);
    this.events.unsubscribe("delete:beer", this.deleteBeerSubscription);
  }

  loadNext(isScroll: boolean, infiniteScroll: IonInfiniteScroll) {
    console.log('[my-analyses] - loadNext');

    if (!this.fetchMore) {
      if (isScroll) {
        infiniteScroll.complete();
      }
      return;
    }

    if (!isScroll) {
      // Say to analyses we are executing a loading function.
      this.isLoading.push(true);

      // Check if we are already showing the please wait, if not show it...
      if (this.isLoading.length > 1) {
        this.executeLoad(isScroll, infiniteScroll);
      } else {
        let loadingPromise = this.createLoading();
        loadingPromise.then((loading) => {
          this.loading = loading;
          this.loading.present().then(() => {
            this.executeLoad(isScroll, infiniteScroll);
          });
        });
      }
    } else {
      this.executeLoad(isScroll, infiniteScroll);
    }
  }

  executeLoad(isScroll, infiniteScroll) {
    this.userData.getUserID()
      .then((userID) => {
        //userID = "5"
        let requestUser = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);

        this.pageNumber++;

        this.analysisService.getMyAnalyses(requestUser, this.pageNumber, this.rowCount, this.sortFilter, (this.selectedVenue ? this.selectedVenue.id : null)).subscribe((resp: any) => {
          console.log("response for analysis: " + this.bhutil.stringify(resp));
          if (resp) {
            resp.forEach(element => {
              this.beers.push(element);
            });
            if (resp.length == 0) {
              this.fetchMore = false;
            }
          }
          else {
            console.log("No response: weird");
          }

          if (isScroll) {
            infiniteScroll.complete();
          } else {
            this.stopLoading();
          }
        }, err => {
          console.log(err);
          if(isScroll) {
            infiniteScroll.complete();
          } else {
            this.stopLoading();
          }
        });
      });
  }

  doInfinite(infiniteScroll) {
    console.log('[my-analyses] - doInfinite');

    this.loadNext(true, infiniteScroll);
  }

  delete(item: IonItemSliding, beer: any, theAnalysisId: any) {
    console.log("my-analyses - removing analyses with id:", theAnalysisId);

    let alertProm = this.alertCtrl.create({
      header: this.translateService.instant('BEERANALYSIS.DELETE_ANALYSIS'),
      message: this.translateService.instant('BEERANALYSIS.AREY_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ANALYSIS'),
      buttons: [
        {
          text: this.translateService.instant('BEERANALYSIS.NO'),
          role: 'cancel',
          handler: () => {
            console.log('No clicked');
            this.expandAction(item, 'not deleting analysis', this.translateService.instant("GENERAL.DELETE_ACTION_CANCELLED"));
          }
        },
        {
          text: this.translateService.instant('BEERANALYSIS.YES'),
          handler: () => {
            console.log('Yes clicked');

            //:::::
            // perform the delete API call
            let analysisRemove: AnalysisRemove = new AnalysisRemove(theAnalysisId);
            this.analysisService.removeAnalysis(analysisRemove).subscribe(resp => {
              console.log("[my-analyses] Resp for removeFromMyAnalyses: " + this.bhutil.stringify(resp));
              item.close();
              //this.expandAction(item, 'removing item from wishlist', 'Beer ' + beerName + ' was removed from your wishlist');
              this.expandAction(item, 'deleting analysis with id ' + beer.id, this.translateService.instant("MYANALYSES.YOUR_ANALYSIS_OF_BEER") + " " + beer.name + " " + this.translateService.instant("MYANALYSES.HAS_BEEN_DELETED"));
              this.refresh();
            }, err => {
              //debugger;
              console.log("remove from my analyses ERROR: " + err.error);
              item.close();
              this.expandAction(item, 'deleting analysis with id ' + beer.id, this.translateService.instant("MYANALYSES.DELETE_ACTOIN_FAILED_TRY_AGAIN_LATER"));
              this.refresh();
            });
            //:::::

            //this.expandAction(item, 'deleting analysis with id ' + beer.id, 'Your analysis of beer ' + beer.beer.name + ' has been deleted.');
          }
        }
      ]
    });
    alertProm.then((alert) => { alert.present() })
  }

  refresh() {

    //debugger;

    //this.pageNumber = 0;
    //this.fetchMore = true;
    //this.loadNext(false, null);

    this.pageNumber = 0;
    this.fetchMore = true;

    this.beers = [];
    this.isLoading.push(true);
    if (this.isLoading.length > 1) {
      this.executeRefresh();
    } else {
        let loadingPromise = this.createLoading();
        loadingPromise.then((loading) => {
          this.loading = loading;
          this.loading.present().then(() => {
            this.executeRefresh()});
        });
    }
  }

  executeRefresh() {
    this.userData.getUserID()
      .then((userID) => {
        //userID = "5"
        let requestUser = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);

        this.pageNumber++;

        this.analysisService.getMyAnalyses(requestUser, this.pageNumber, this.rowCount, this.sortFilter, (this.selectedVenue ? this.selectedVenue.id : null)).subscribe((resp: any) => {
          console.log("response for analysis: " + this.bhutil.stringify(resp));
          if (resp) {
            resp.forEach(element => {
              this.beers.push(element);
            });
            if (resp.length == 0) {
              this.fetchMore = false;
            }
          }
          else {
            console.log("No response: weird");
          }

          this.stopLoading();
        }, err => {
          this.stopLoading();
          console.log(err);
        });
      });
  }

  expandAction(item: IonItemSliding, _: any, text: string) {
    // TODO item.setElementClass(action, true);
    setTimeout(() => {
      const toastProm = this.toastCtrl.create({
        message: text
      });
      toastProm.then((toast) => {
        toast.present();
        // TODO item.setElementClass(action, false);
        item.close();
        setTimeout(() => toast.dismiss(), 2000);
      })
    }, 150);
  }

  showBeerDetail(b: any) {
    console.log("TODO: show details for beer " + this.bhutil.stringify(b));
    //console.log("beer id is " + b.beer.id);
    //navigate to the detail screen, with the info preloaded
    this.router.navigate([ BeerDetailPage_PATH ], { state: { data: {
        'beer': b,
        'sourcetype': 'my-analyses',
        'sourceID': 2
      }}});
    //sourceID 2 == MY-ANALYSES
  }

  getImageUrl(b: any) {
    //console.log("getImageUrl for beer id: " + b.beer.id);

    if (b.beer.logo !== undefined && b.beer.logo != null) {
      let logoUrlBeer = this.refdata.getEnvVar('beerLogoBaseUrl') + b.beer.logo;
      //console.log("LOGO - using beer logo: " + logoUrlBeer);
      return logoUrlBeer;
    } else if (b.beer.brewery.logo !== undefined && b.beer.brewery.logo != null) {
      let logoUrlBrewery = this.refdata.getEnvVar('breweryLogoBaseUrl') + b.beer.brewery.logo;
      //console.log("LOGO - using brewery logo: " + logoUrlBrewery);
      return logoUrlBrewery;
    }
    else {
      let logoNoLogo = "../assets/svg/icon_beerglass.svg";
      //console.log("LOGO - using placeholder logo (no_logo: " + logoNoLogo);
      return logoNoLogo;
    }
  }

  createLoading(): Promise<HTMLIonLoadingElement> {
    return this.loadingCtrl.create({
      message: this.translateService.instant('GENERAL.PLEASE_WAIT')
    });
  }

  stopLoading() {
    this.isLoading.pop();
    if (this.isLoading.length == 0) {
      this.loading.dismiss();
    }
  }

  getValueStr(b: any, value: string) {
    let v = eval("b.beer." + value);
    if (v && v != "") {
      v = Math.round(v * 10) / 10;
      if (value == "abv") {
        v += "%";
      }
      return v + " " + this.translateService.instant("ADDBEER." + value.toUpperCase());
    }
  }

  hasAtLeastOneValue(beer: any) {
    return beer.abv || beer.ibu || beer.ebc;
  }

  getDropSize(dropNr, beer) {
    let rating = beer.totalexperience;
    if (rating) {
      if (dropNr <= rating) {
        return "assets/svg/icon_bh_" + "full" + ".svg";
      } else if (dropNr == rating + 0.5) {
        return "assets/svg/icon_bh_" + "half" + ".svg";
      } else {
        return "assets/svg/icon_bh_" + "empty" + ".svg";
      }
    }
  }
}
